module.exports = __webpack_public_path__ + "img/do.d052e0b2.png";